module.exports = __webpack_public_path__ + "static/media/vps-n8n-br.8d53c7a3.png";